<script setup>
import i18n from "@/i18n"
import {
    ref, defineProps, defineEmits,
    computed,
    inject
} from "vue";
import { uploadFile } from "@/service";
import { useRoute } from "vue-router";
import SwiperTool from "@/components/swiperTool.vue";
import customTableCom from "./customTable.vue";
// import { getFileUrl } from "@/service"
import {
    getLangValue, // getExcelData
} from "@/utils/common"; //获取后端语言
// 注入通知函数
const openAlert = inject('openAlert')
const props = defineProps({
    customFieldsList: {
        type: Array,
        required: true,
        default: () => []
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
})
const route = useRoute()
const emits = defineEmits(["update:customFieldsList"])
// const { customFieldsList } = toRefs(props)
const customFieldsList = ref(computed(() => props.customFieldsList))

// watch(() => props.customFieldsList, (newVal) => {
//     customFieldsList.value = newVal;
//     // newVal.forEach(item => {
//     //     if (item.value && item.value.length) {
//     //         let ids = item.value.join(',')
//     //         getFileUrl({ attachments: ids }).then(res => {
//     //             res.payload.map(item => {
//     //                 item.filename = item.name
//     //             })
//     //             item.fileList = res.payload
//     //         })
//     //     }
//     // })
// });

//方法
/**文件上传部分 */
const checkFile = (index, file) => {
    const { fileList, accept } = customFieldsList.value[index]
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf("."));
    if (!accept) return true
    // 判断是否属于指定的类型
    if (accept.indexOf(suffix) == -1) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notCorrectType"),
            },
        );
        return false;
    }
    // 判断是否是同一个文件
    let arr = fileList.filter(item => item.filname == name)
    if (arr.length > 0) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notSameFile"),
            },
        );
        return false;
    }
    return true;
}
const selectedFile = (index) => {
    let idStr = '#' + customFieldsList.value[index].id;
    let fileMaxSize = customFieldsList.value[index].fileMaxSize
    let dropzoneFile = document.querySelector(idStr).files[0];
    if (!dropzoneFile) return;
    if (dropzoneFile.size > fileMaxSize) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.limit"),
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    if (!checkFile(index, dropzoneFile)) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notSameFile"),
            },
            false
        );
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    uploadFile(dropzoneFile)
        .then(async (res) => {
            customFieldsList.value[index].fileList.push(res.data.payload);
            emits("update:customFieldsList", customFieldsList.value)
            //清除上一张图片
            document.querySelector(idStr).value = ''
            // if (customFieldsList.value[index].id == 'FTTFiledUpload') {
            //     const dat_data = await getExcelData(dropzoneFile)
            //     console.log(dat_data);
            // }
        })
        .catch((e) => {
            console.log(e);
        });

}
const drop = (e) => {
    let dropzoneFile = e.dataTransfer.files[0];
    if (!dropzoneFile) return;
}
const deleteFile = (i, _type, index) => {
    customFieldsList.value[index].fileList.splice(i, 1);
    emits("update:customFieldsList", customFieldsList.value)
}

/**文件上传部分 */
</script>
<template>
    <b-card v-for="(item, index) in customFieldsList" :key="index">
        <div class="row gy-3 w-100">
            <div class="d-flex justify-content-start align-items-center  pb-2"
                style="font-weight: bold;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                <div>
                    <label class="form-label">
                        <span>{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</span>
                    </label>
                    <!-- <input :disabled="route.query.type == 'view'" v-else type="text" class="form-control"
                        v-model="item.name" :placeholder="getLangValue('product_template.text')" /> -->
                </div>
            </div>
            <!-- 字段部分 -->
            <div class="row  d-flex justify-content-start">
                <!-- 新增字段部分 -->
                <div class="col-4 mt-2" v-for="(field, index_field) in item.fieldsList" :key="index_field">
                    <label class="form-label">
                        <span v-if="field.required" class="text-danger">*</span>
                        <span>{{ i18n.global.locale == 'en' ? field.name_en : field.name }}</span>
                    </label>
                    <div class="d-flex align-items-center">
                        <div style="display: inline; flex:1">
                            <el-select :class="[(isCheckForm && !field.value && field.required) && 'is-invalid122']"
                                v-if="field.type == 'select'" v-model="field.value" placeholder=" " size="large"
                                style="width: 100%; height: 37.5px; " clearable filterable allow-create
                                :disabled="route.query.type == 'view'">
                                <el-option v-for="(item1,key) in field.list" :key="key" :label="i18n.global.locale=='en'?  item1.name_en || item1 : item1.name || item1" :value="i18n.global.locale=='en'?  item1.name_en || item1 : item1.name || item1" />
                            </el-select>
                            <div class="input-group" style="display: flex;" v-else>
                                <input :class="[(isCheckForm && !field.value && field.required) && 'is-invalid']"
                                    type="text" :disabled="route.query.type == 'view'" v-model="field.value"
                                    class="form-control" style="flex: 1;">
                                <input disabled v-model="field.unit" class="form-control" v-if="field.unit"
                                    style="max-width:100px; display: inline;" @change="changeUnit" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 上传框 -->
            <div v-if="item.showUpload" :style="route.query.type == 'view' ? { pointerEvents: 'none' } : {}">
                <DropZone :ipt-id="item.id" :title="getLangValue('upload.title')" :accept="item.accept"
                    @drop.prevent="drop" @change.prevent="selectedFile(index)" style="min-height: 220px"
                    :info="item.info ? item.info : getLangValue('upload.limit') + '200M'" />
            </div>
            <!-- 预览 -->
            <div class=" border-solid rounded p-3" v-show="item.fileList && item.fileList.length">
                <div>
                    <div class="border-primary fs-14 material-title">{{ getLangValue("upload.uploadedFile") }}
                    </div>
                </div>
                <div class="product-img-slider  ps-5 pe-5">
                    <SwiperTool :swiperInfo="{
                        type: 'image',
                        page: 'assetform',
                        spaceBetween: 10,
                        slidesPerView: 15,
                        actionsClass: route.query.type != 'view' ? [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ] : [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                        ],
                    }" :list="item.fileList" @deleteFile="(...args) => deleteFile(...args, index)">
                    </SwiperTool>
                </div>
            </div>
            <!-- 表格信息 -->
            <customTableCom :customTableList="item.tabList" v-if="item.showTable" />
        </div>
    </b-card>
</template>
<style scoped>
.is-invalid122 {
    border: 1px solid #f06548 !important;
    border-radius: 4px;
}

:deep(.el-select__wrapper) {
    min-height: unset;
    height: 100%;
}
</style>